import React, {Component} from 'react';
import './CustomerItemTableHeader.css';
import {FormattedMessage} from "react-intl";


class CustomerItemTableHeader extends Component {

    render() {
        return (
            <div>
                <div className="row view-details-table-header">
                    <div className="col-md-2">
                        <label className="admin-view-single-order-label">
                        <FormattedMessage id="app.admin.view.single.order.item"
                                          defaultMessage="Item"
                                          description=""/>
                        </label>
                    </div>
                    <div className="col-md-3">
                        <label className="admin-view-single-order-label">
                            <FormattedMessage id="app.admin.view.single.order.file"
                                              defaultMessage="Item File"
                                              description=""/>
                        </label>
                    </div>
                    {/*<div className="col-md-2">*/}
                        {/*<label className="admin-view-single-order-label">*/}
                           {/*/!* <FormattedMessage id="app.admin.view.single.order.qty"*/}
                                              {/*defaultMessage="Qty"*/}
                                              {/*description=""/>*!/*/}
                            {/*<FormattedMessage id="app.admin.view.single.order.item"*/}
                                              {/*defaultMessage="Item"*/}
                                              {/*description=""/>*/}
                        {/*</label>*/}
                    {/*</div>*/}
                    <div className="col-md-2 ">
                        <label className="admin-view-single-order-label pull-right order-view-table-cost pull-left">
                            <FormattedMessage id="app.admin.view.single.order.quantity"
                                              defaultMessage="Qty"
                                              description=""/>
                        </label>
                    </div>

                    <div className="col-md-2">
                        <label className="admin-view-single-order-label">
                            <FormattedMessage id="app.admin.view.single.order.total"
                                              defaultMessage="Item Cost"
                                              description=""/>(¥)
                        </label>
                    </div>
                    <div className="col-md-1">
                         <label className="admin-view-single-order-label pull-right order-view-table-cost pull-left">
                            <FormattedMessage id="app.admin.view.single.order.weight"
                                              defaultMessage="Weight"
                                              description=""/>(g)
                        </label>
                    </div>
                    <div className="col-md-2">
                        <label className="admin-view-single-order-label pull-right order-view-table-cost pull-left">
                            <FormattedMessage id="app.admin.view.single.order.operation"
                                              defaultMessage="Actions"
                                              description=""/>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <hr className="admin-single-order-header-hr"/>
                </div>
            </div>
        )
    }
}
export default CustomerItemTableHeader;



// WEBPACK FOOTER //
// ./src/components/Site/Order/SingleOrder/CustomerItemTableHeader/CustomerItemTableHeader.js